import { delay, put, select, takeLatest } from "redux-saga/effects";
import { Notify } from "../../../UIcomponent/NotificationManager";
import DashboardReq from "../../../Utility/Requester/DashboardReq";
import actions from "../../actions";

export const getModalData = (state) => state.dashboard.reviewModal.data;

export default function* review() {
  yield takeLatest(
    actions.dashboard.review.SET_REVIEW_REQUEST,
    function* ({ params }) {
      try {
        let { session, mode } = yield select(getModalData);
        if (mode === 0) {
          yield DashboardReq.UserReview(session.Session.ID, params);
        } else {
          yield DashboardReq.LingoReview(session.Session.ID, params);
        }

        yield put({
          type: actions.dashboard.review.SET_REVIEW_SUCCESS,
        });

        if (mode === 0) {
          yield put(actions.dashboard.reviewModal.setData({ mode: 1 }));
        } else {
          yield put(actions.dashboard.reviewModal.setData({ mode: 2 }));
          yield delay(4000);
          yield put(actions.dashboard.reviewModal.reset());
        }
      } catch (error) {
        yield Notify("error", error.response.data.message);
        yield put({
          type: actions.dashboard.review.SET_REVIEW_ERROR,
        });
      }
    }
  );
}
